import axios from 'axios';
import baseUrl from '../baseUrl/baseUrl';

const instance = axios.create();

const request = (method, url, data, headers = {}, baseHost = '', token = '') =>
  new Promise((resolve, reject) => {
    instance.defaults.headers.common = {
      Authorization: `Bearer ${token || localStorage.getItem('logintoken')}`,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    instance.defaults.baseURL = baseHost || baseUrl.url;
    (() => {
      if (method === 'get') {
        return instance.request({
          url,
          method,
          params: data,
          headers,
        });
      }
      return instance.request({
        url,
        method,
        data,
        headers,
      });
    })()
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        if (err.response && err.response.status === 403) {
          window.dispatchEvent(new Event('session-expired'));
          return;
        }
        const { data: error } = err.response || {};
        reject(error);
      });
  });

export const Request = {
  get: (endpoint, data, headers, baseHost, token) =>
    request('get', endpoint, data, headers, baseHost, token),
  post: (endpoint, data, headers) => request('post', endpoint, data, headers),
  put: (endpoint, data) => request('put', endpoint, data),
  del: (endpoint, data) => request('delete', endpoint, data),
  patch: (endpoint, data) => request('patch', endpoint, data),
};
